import React, {useState} from 'react';
import {Control, useWatch} from 'react-hook-form';
import {IconButton, Stack, Tooltip} from '@mui/material';
import {AsyncSelect, Button, ControlledTextField} from '../../../../../components/forms';
import {EntityWithIdAndDescriptionFields} from '../../../../../types';
import {OperacionLCTCLimiteTipo} from "../types/dto";
import MenuIcon from '@mui/icons-material/Menu';

interface OperacionLCTCCampoLimiteProps {
    control: Control<any>;
    name: string;
    label: string;
    loadOptions: () => Promise<OperacionLCTCLimiteTipo[]>;
    onModeChange?: (isFreeSolo: boolean) => void;
    disabled?: boolean;
    buttonType?: 'standard' | 'icon';
    fullWidth?: boolean;
}

export const OperacionLCLTCampoLimite = ({
                                             control,
                                             name,
                                             label,
                                             loadOptions,
                                             onModeChange,
                                             disabled,
                                             buttonType = 'standard',
                                             fullWidth = true,
                                         }: OperacionLCTCCampoLimiteProps) => {
    const fieldValue = useWatch({control, name});

    const [isFreeSolo, setIsFreeSolo] = useState<boolean | undefined>(false);

    // dejo esto comentado porque este flujo no permite valores libres, pero quizas luego lo piden cambiar
    // este useEffect es para poner el input en modo freeSolo si el valor actual no es una de las opciones
    // useEffect(() => {
    //     const initialValue = control._formValues[name];
    //
    //     if (initialValue === null || initialValue === undefined) {
    //         setIsFreeSolo(false);
    //         if (onModeChange) onModeChange(false);
    //
    //         return;
    //     }
    //
    //     loadOptions().then(allOptions => {
    //         const valueExists = allOptions.some(
    //             option => option[OperacionLCTCFields.Monto] === initialValue
    //         );
    //
    //         const shouldBeFreeSolo = !valueExists;
    //         setIsFreeSolo(shouldBeFreeSolo);
    //         if (onModeChange) onModeChange(shouldBeFreeSolo);
    //     });
    // }, []);
    //
    // useEffect(() => {
    //     if (isFreeSolo === undefined) return;
    //
    //     if (fieldValue === null) {
    //         setIsFreeSolo(true);
    //         onModeChange && onModeChange(true);
    //     }
    // }, [fieldValue, onModeChange]);

    const renderToggleButton = () => {
        const commonProps = {
            size: 'small',
            color: 'primary',
            onClick: () => {
                setIsFreeSolo(false);
                onModeChange && onModeChange(false);
            },
            disabled: disabled
        } as const;

        if (buttonType === 'icon') {
            return (
                <Tooltip title="Ver opciones">
                    <span>
                        <IconButton {...commonProps}>
                            <MenuIcon fontSize="small"/>
                        </IconButton>
                    </span>
                </Tooltip>
            );
        }

        return (
            <Button {...commonProps}>
                Opciones
            </Button>
        );
    };

    if (!isFreeSolo) {
        return (
            <AsyncSelect
                control={control}
                name={name}
                label={label}
                loadOptions={loadOptions}
                selectNotNulleable
                fullWidth={fullWidth}
                valueField={EntityWithIdAndDescriptionFields.Description}
                descriptionField={EntityWithIdAndDescriptionFields.Description}
                disabled={disabled}
            />
        );
    }

    return (
        <Stack direction={'row'} gap={1} alignItems="center">
            <ControlledTextField
                name={name}
                label={label}
                control={control}
                size='small'
                autoFocus
                currency
                prefix={'%'}
                fullWidth={fullWidth}
                disabled={disabled}

            />
            {renderToggleButton()}
        </Stack>
    );
};